/**
 * Plans API Service
 * 
 * Handles API calls related to subscription plans and billing
 */

import { api } from './api'

export interface Plan {
  id: string
  name: string
  display_name: string
  description?: string
  price_monthly: number
  price_yearly?: number
  messages_limit: number
  team_members_limit: number
  chatbots_limit: number
  storage_limit_mb: number
  features: Record<string, any>
  is_active: boolean
  sort_order: number
}

export interface CurrentSubscription {
  plan_id?: string
  plan_name?: string
  plan_display_name?: string
  status: string
  current_period_start?: string
  current_period_end?: string
  amount?: number
}

export interface UserPlansResponse {
  current_subscription: CurrentSubscription
  available_plans: Plan[]
}

export interface UpgradeResponse {
  success: boolean
  message: string
  plan: {
    id: string
    name: string
    display_name: string
    price: number
  }
  paddle_customer_id?: string
  paddle_subscription_id?: string
  paddle_price_id?: string
  paddle_environment?: string
}

/**
 * Get user's current subscription and available plans
 */
export const getUserPlans = async (): Promise<UserPlansResponse> => {
  const response = await api.get<UserPlansResponse>('/user/plans/')
  return response.data
}

/**
 * Upgrade user to a new plan
 */
export const upgradePlan = async (planId: string): Promise<UpgradeResponse> => {
  const response = await api.post<UpgradeResponse>(`/user/plans/upgrade/${planId}`)
  return response.data
}